import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DataStreamService } from '@portal-core/data-stream/services/data-stream.service';

export const dataStreamInitResolver: ResolveFn<boolean> = (): boolean => {
  const dataStreamService = inject(DataStreamService);

  dataStreamService.init();

  return true;
}
